/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Food Security Exchange API
 * REST API for the FSE platform. Endpoints by BRS module (PLAN.md §5).
 * OpenAPI spec version: 0.0.1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ContributionDto,
  ContributionListDto,
  ContributionsControllerListParams,
  CreateContributionDto
} from '.././models';

import { fseAxios } from '../../client';




/**
 * Caller scope: admin = any; coop_admin = batches in own coop; farmer = own contributions only. Batch must be status=open. clientOpId enables idempotent retries from the mobile SyncEngine outbox.
 * @summary Record a contribution to an open batch
 */
export const contributionsControllerCreate = (
    createContributionDto: CreateContributionDto,
 signal?: AbortSignal
) => {
      
      
      return fseAxios<ContributionDto>(
      {url: `/contributions`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createContributionDto, signal
    },
      );
    }
  


export const getContributionsControllerCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof contributionsControllerCreate>>, TError,{data: CreateContributionDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof contributionsControllerCreate>>, TError,{data: CreateContributionDto}, TContext> => {

const mutationKey = ['contributionsControllerCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof contributionsControllerCreate>>, {data: CreateContributionDto}> = (props) => {
          const {data} = props ?? {};

          return  contributionsControllerCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ContributionsControllerCreateMutationResult = NonNullable<Awaited<ReturnType<typeof contributionsControllerCreate>>>
    export type ContributionsControllerCreateMutationBody = CreateContributionDto
    export type ContributionsControllerCreateMutationError = unknown

    /**
 * @summary Record a contribution to an open batch
 */
export const useContributionsControllerCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof contributionsControllerCreate>>, TError,{data: CreateContributionDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof contributionsControllerCreate>>,
        TError,
        {data: CreateContributionDto},
        TContext
      > => {

      const mutationOptions = getContributionsControllerCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Must filter by at least one of batchId or farmerUserId. Scope intersects with the filter: farmer sees own; coop_admin sees own-coop batches; admin sees all.
 * @summary List contributions (filter by batchId and/or farmerUserId)
 */
export const contributionsControllerList = (
    params?: ContributionsControllerListParams,
 signal?: AbortSignal
) => {
      
      
      return fseAxios<ContributionListDto>(
      {url: `/contributions`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getContributionsControllerListQueryKey = (params?: ContributionsControllerListParams,) => {
    return [
    `/contributions`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getContributionsControllerListQueryOptions = <TData = Awaited<ReturnType<typeof contributionsControllerList>>, TError = unknown>(params?: ContributionsControllerListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contributionsControllerList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getContributionsControllerListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof contributionsControllerList>>> = ({ signal }) => contributionsControllerList(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof contributionsControllerList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ContributionsControllerListQueryResult = NonNullable<Awaited<ReturnType<typeof contributionsControllerList>>>
export type ContributionsControllerListQueryError = unknown


export function useContributionsControllerList<TData = Awaited<ReturnType<typeof contributionsControllerList>>, TError = unknown>(
 params: undefined |  ContributionsControllerListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof contributionsControllerList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof contributionsControllerList>>,
          TError,
          Awaited<ReturnType<typeof contributionsControllerList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useContributionsControllerList<TData = Awaited<ReturnType<typeof contributionsControllerList>>, TError = unknown>(
 params?: ContributionsControllerListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contributionsControllerList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof contributionsControllerList>>,
          TError,
          Awaited<ReturnType<typeof contributionsControllerList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useContributionsControllerList<TData = Awaited<ReturnType<typeof contributionsControllerList>>, TError = unknown>(
 params?: ContributionsControllerListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contributionsControllerList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List contributions (filter by batchId and/or farmerUserId)
 */

export function useContributionsControllerList<TData = Awaited<ReturnType<typeof contributionsControllerList>>, TError = unknown>(
 params?: ContributionsControllerListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contributionsControllerList>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getContributionsControllerListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




